import { render, staticRenderFns } from "./withdrawalRequests.vue?vue&type=template&id=629d0bf0"
import script from "./withdrawalRequests.vue?vue&type=script&lang=js"
export * from "./withdrawalRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports